module.exports = __webpack_public_path__ + "img/diagram_5_1.45e785ad.png";